import * as parsisgrp from "./parsis";

function toJqueryInstance(selector) {

    const $ = jQuery;

    if (!selector) return $();
    else if (selector instanceof $) return selector;
    else if (typeof selector === "string") return $("#" + selector);
    else return $(selector);
}

const UIEvents = function (wrap, events, callback) {
    let $wrap = toJqueryInstance(wrap);

    if ($wrap && $wrap.length) {

        const bind = function () {
            let $el     = jQuery(this),
                handler = $el.attr("data-event") || $el.attr("@event"),
                type    = $el.attr("data-event-type") || $el.attr("@type"),
                event   = {handler: null, type: null, data: {}},
                obj;

            if (handler.indexOf("{") + 1 > 0 && handler.lastIndexOf("}")) {

                obj = eval("(" + handler + ")");

                event.handler = obj.handler || obj.action;
                event.type = obj.type;
                event.data = obj.data;
            } else {
                event.handler = handler;
                event.type = type;
            }

            if (events[event.handler]) {
                $el.on(event.type || "click", event.data, function (e) {
                    events[event.handler].call(events, this, e)
                }).removeAttr("data-event data-event-type @event");
            }

        }

        $wrap.find("[data-event]").each( bind );

        $wrap.find('*:attrStartsWith("@event")').each( bind );

        callback && callback();
    }
}

export const events = {
    bind: UIEvents
};